import {
  Grid,
  Drawer,
  Form,
  Space,
  Avatar,
  Card,
  Typography,
  Tag,
  Divider,
} from '@pankod/refine-antd';
// import { ESourceTransactionType } from 'enums';
import defaultAvatar from 'assets/images/default-avatar.jpg';
import styles from './style.module.css';
import { IExpense } from 'interfaces';
import { IExpenseRecord } from 'utilities/expense-csv';

const { Title, Text } = Typography;

type ExpenseDrawerProps = {
  title: string;
  visible: boolean;
  record: IExpenseRecord;
  onClose: () => void;
  setExpenses: React.Dispatch<React.SetStateAction<IExpense[]>>;
};

export const ShowExpenseDrawer: React.FC<ExpenseDrawerProps> = (props) => {
  const [form] = Form.useForm();
  const breakpoint = Grid.useBreakpoint();

  // const { salesExpense, purchaseExpense, returnExpense, damageExpense } = props.record;
  // const salesExpenseObject = salesExpense && salesExpense[0];
  // const purchaseExpenseObject = purchaseExpense && purchaseExpense[0];
  // const returnExpenseObject = returnExpense && returnExpense[0];
  // const damageExpenseObject = damageExpense && damageExpense[0];

  // const sourceTransaction =
  //   (salesExpenseObject && ESourceTransactionType.Sales) ||
  //   (purchaseExpenseObject && ESourceTransactionType.Purchases) ||
  //   (returnExpenseObject && ESourceTransactionType.Return) ||
  //   (damageExpenseObject && ESourceTransactionType.Damage) ||
  //   ESourceTransactionType.Expense;

  const onShowClose = () => {
    form.resetFields();
    props.onClose();
  };

  const expensePhoto = props?.record?.expensePhoto;
  const avatarURL = expensePhoto[expensePhoto?.length - 1]?.avatar?.url;

  return (
    <Drawer
      title={props.title}
      placement="right"
      width={breakpoint.sm ? '450px' : '100%'}
      onClose={onShowClose}
      visible={props.visible}
    >
      <Card title="Expense Information">
        <Space direction="vertical" className={styles['file-upload']}>
          <Avatar
            size={200}
            style={{ objectFit: 'cover' }}
            src={avatarURL || defaultAvatar}
            alt={`Avatar`}
          />
        </Space>
        <Divider />
        {/* <Title level={5}>Source Transactions</Title>
        <Text>{sourceTransaction}</Text> */}
        <Title level={5}>Expense Category</Title>
        <Text>
          <Tag key={props.record.category?.name} color="blue">
            {props.record.category?.name}
          </Tag>
        </Text>
        <Title level={5}>Client/Supplier</Title>
        <Text>{props.record.userName}</Text>
        <Title level={5}>Expense Warehouse</Title>
        <Text>{props.record.expenseWarehouse}</Text>
        <Title level={5}>Note</Title>
        <Text>{props.record.note}</Text>
        <Title level={5}>Amount</Title>
        <Text>{props.record.amount}</Text>
      </Card>
    </Drawer>
  );
};
